// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export const NoiseReductionLinks = registerClientReference(
function() { throw new Error("Attempted to call NoiseReductionLinks() from the server but NoiseReductionLinks is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/components/navbar/NoiseReductionLinks.tsx",
"NoiseReductionLinks",
);